<template>
	<div>
		<div class="mianPage">
			<!-- <div class="URLOptionTxts flex_center">
				<div class="URLOptionTxt tableURLTxt" title="https://contentcenter-drcn.dbankcdn.cn/img/pub_17/PPS_realtimeimage_100_1/ed/v3/Vtw6p3iLT3iYZ_3Y6g-d_g/sViFdyOFREOswi0twsY5yQ.jpg/__source__.jpg">
						https://contentcenterdrcn.dbankcdn.cn/img/pub_17/PPS_realtimeimage_100_1/ed/v3/Vtw6p3iLT3iYZ_3Y6g-d_g/sViFdyOFREOswi0twsY5yQ.jpg/__source__.jpg
				</div>
				<div style="width: 10px;"></div>
			</div> -->
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-select v-model="queryData.companyId" filterable clearable size="small" placeholder="请选择媒体公司">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.os" clearable size="small" placeholder="请选择操作系统">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-select v-model="queryData.appId" filterable clearable size="small" placeholder="请选择应用">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :value="item"
								:label="`应用：${item.label} | ${item.value}`">
								<!-- :label="`应用：${item.label} | ${item.value}`" -->
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<div class="query-menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['dataReport:versionStatistics:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['dataReport:versionStatistics:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<div class="statisticsBox">
				<div>
					<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
					</el-date-picker>
				</div>
				<div class="statisticsList">
					<div class="statisticsOne" v-for="(item,index) in statisticsList" :key="index">
						<div class="statisticsPercent">{{item.ratio}}%</div>
						<div class="statisticsRow flex_start">
							<div class="statisticsName">{{index+1}}、{{item.sdkVersionName}}</div>
							<div class="statisticsBar">
								<div class="statisticsProgress" :style="{ width: `${item.ratio}%` }"><div class="statisticsNum">{{item.total}}人</div></div>
							</div>
						</div>
						<div class="statisticsName" style="padding-left: 24px;">版本号：{{item.sdkVersion}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				datePicker: [], // 日期选择
				companyOptions: [], // 公司下拉选择列表
				osOptions: this.$api.osOptions, // OS下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				
				queryData: {}, // 列表请求筛选项
				statisticsList: [],
			}
		},
		mounted() {
			// console.log(JSON.stringify(this.ruleFormData));
			this.dateInit();
			// this.getOSOption();
			this.getCompanyOption();
			this.getMediaAppOption();
			this.getTableData();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				this.datePicker = []
				let currentDate = new Date();
				let year = currentDate.getFullYear();
				let month = String(currentDate.getMonth() + 1).padStart(2, '0');
				let day = String(currentDate.getDate()).padStart(2, '0');
				let formattedDate = `${year}-${month}-${day}`;
				this.datePicker.push(formattedDate);
				this.datePicker.push(formattedDate);
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			appSeleteChange(e) {
				this.appSelectForm = e
			},
			appRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				}, 300)
			},
			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			async getTableData() {
				let data = {
					// pageNum: 1,
					// pageSize: 10,
					startDate: '',
					endDate: '',
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				if(this.appSelectForm.value){
					data['appId'] = this.appSelectForm.value
				}
				let res = await this.$http.post(this.$api.dataManage.versionStatistic, data);
				this.statisticsList = res.data
				// this.total = res.data.totalRecord
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.appSelectForm = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}
	/deep/ .el-form-item__content {
		line-height: 32px;
	}
	
	.query-menu-right {
		margin-left: auto;
		/* margin-bottom: 10px; */
	}
	.statisticsBox{
		margin-top: 10px;
		background: #ffffff;
		padding: 24px 16px;
	}
	.statisticsList{
		padding: 48px 0;
	}
	.statisticsPercent{
		width: 50px;
		height: 42px;
		background: url(../../assets/icon/statisticsPercent.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		border-radius: 2px;
		font-weight: 600;
		font-size: 12px;
		color: #333333;
		text-align: center;
		padding-top: 8px;
		box-sizing: border-box;
		margin-left: 210px;
	}
	.statisticsOne{
		margin-top: 30px;
		padding-left: 36px;
	}
	.statisticsRow{
		align-items: center;
		margin-top: 15px;
	}
	.statisticsName{
		font-weight: 600;
		font-size: 14px;
		color: #333333;
		width: 200px;
		line-height: 28px;
	}
	.statisticsBar{
		width: 70%;
		margin-left: 10px;
		height: 20px;
	}
	.statisticsProgress{
		background: #007FFF;
		/* width: 50%; */
		height: 100%;
		position: relative;
		border-radius: 2px;
	}
	.statisticsNum{
		font-size: 14px;
		color: #333333;
		width: 150px;
		position: absolute;
		right: -160px;
		top: 0;
	}
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
	.URLOptionTxts {
		/* overflow: hidden;
		text-overflow: ellipsis; */
		width: 230px;
	}
	
	
	.URLOptionTxt {
		width: 400px;
		display: block;
		position: relative;
		background: inherit;
		text-align: justify;
		overflow: hidden;
		white-space: normal !important;
		text-overflow: clip !important;
		height: 34px;
		line-height: 34px;
		font-size: 14px;
	}
	
	.URLOptionTxt::before {
		content: attr(title);
		width: 30%;
		/* float: right; */
		position: absolute;
		right: 0;
		top: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		direction: rtl;
		box-sizing: border-box;
		z-index: 10;
		background-color: #EFF3F5;
	}
	
	.tableURLTxt {
		/* height: 24px;
		line-height: 24px; */
		width: 220px;
	}
	.clearfix::after {
		content: "";
		display: table;
		clear: both;
	}
</style>